<template>
  <div class="ai-cards">
    <article v-for="card in visibleCards" :key="card.key" class="ai-card">
      <div class="ai-card-main">
        <span class="ai-card-icon"><i :class="card.icon"></i></span>
        <div class="ai-card-body">
          <div class="ai-card-title">{{ card.title }}</div>
          <div v-if="card.subtitle" class="ai-card-subtitle">{{ card.subtitle }}</div>
        </div>
        <div v-if="card.amount" class="ai-card-amount">{{ card.amount }}</div>
      </div>
      <div v-if="card.date || card.status" class="ai-card-meta">
        <span>{{ card.date }}</span>
        <span v-if="card.status" class="ai-card-status" :class="`tone-${card.tone}`">{{ card.status }}</span>
      </div>
      <button v-if="card.route" type="button" class="ai-card-action" @click="$emit('navigate', card.route)">
        {{ card.actionLabel }} <i class="fas fa-arrow-right"></i>
      </button>
    </article>

    <button v-if="hiddenCount > 0" type="button" class="ai-cards-more" @click="expanded = true">
      Afficher {{ hiddenCount }} résultat(s) de plus
    </button>
    <button v-else-if="expanded && cards.length > limit" type="button" class="ai-cards-more" @click="expanded = false">
      Réduire la liste
    </button>
  </div>
</template>

<script>
export default {
  name: 'AssistantResultCards',
  props: {
    cards: { type: Array, required: true },
    limit: { type: Number, default: 4 },
  },
  emits: ['navigate'],
  data() {
    return { expanded: false };
  },
  computed: {
    visibleCards() {
      return this.expanded ? this.cards : this.cards.slice(0, this.limit);
    },
    hiddenCount() {
      return this.expanded ? 0 : Math.max(this.cards.length - this.limit, 0);
    },
  },
};
</script>

<style scoped>
.ai-cards {
  display: grid;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
}

.ai-card {
  padding: 12px;
  border: 1px solid var(--ai-line);
  border-radius: 12px;
  background: var(--ai-surface);
  transition: border-color 140ms ease, box-shadow 140ms ease;
}

.ai-card:hover {
  border-color: var(--ai-primary-line);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
}

.ai-card-main {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.ai-card-icon {
  flex: 0 0 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--ai-primary-soft);
  color: var(--ai-primary);
  display: grid;
  place-items: center;
  font-size: 12px;
}

.ai-card-body {
  flex: 1;
  min-width: 0;
}

.ai-card-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--ai-ink);
  overflow-wrap: anywhere;
}

.ai-card-subtitle {
  margin-top: 2px;
  font-size: 12px;
  color: var(--ai-muted);
  overflow-wrap: anywhere;
}

.ai-card-amount {
  font-size: 13px;
  font-weight: 700;
  color: var(--ai-ink);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.ai-card-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding-left: 40px;
  font-size: 12px;
  color: var(--ai-muted);
}

.ai-card-status {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  background: var(--ai-soft);
  color: #475569;
}

.ai-card-status.tone-success { background: #ecfdf5; color: #047857; }
.ai-card-status.tone-warning { background: #fffbeb; color: #b45309; }

.ai-card-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 10px 0 0 40px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--ai-primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.ai-card-action i {
  font-size: 10px;
  transition: transform 140ms var(--ai-ease);
}

.ai-card-action:hover i {
  transform: translateX(2px);
}

.ai-cards-more {
  height: 34px;
  border: 1px dashed var(--ai-line-strong);
  border-radius: 10px;
  background: transparent;
  color: var(--ai-muted);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.ai-cards-more:hover {
  border-color: var(--ai-primary-line);
  color: var(--ai-primary);
}
</style>
